/**
 * 채점봇 아바타 컴포넌트
 * 감정 상태에 따라 다른 픽셀 아트 표시
 */

import React from 'react';
import { BotEmotion } from '../../types/chat';

/**
 * BotAvatar Props
 */
interface BotAvatarProps {
  /** 채점봇 감정 상태 */
  emotion?: BotEmotion;
  /** 크기 */
  size?: 'small' | 'medium' | 'large';
}

/**
 * 채점봇 아바타 컴포넌트
 *
 * - 픽셀 아트 로봇 캐릭터
 * - 감정별 다른 표정 (이모지 사용)
 * - 레트로 게임 스타일
 */
export const BotAvatar: React.FC<BotAvatarProps> = ({
  emotion = 'neutral',
  size = 'medium',
}) => {
  /**
   * 감정에 따른 이모지 매핑
   */
  const emotionEmojis: Record<BotEmotion, string> = {
    happy: '😊',
    thinking: '🤔',
    excited: '🎉',
    encouraging: '💪',
    neutral: '🤖',
  };

  /**
   * 크기별 스타일
   */
  const sizeClasses = {
    small: 'w-8 h-8 text-lg',
    medium: 'w-12 h-12 text-2xl',
    large: 'w-16 h-16 text-4xl',
  };

  return (
    <div
      className={`
        ${sizeClasses[size]}
        flex items-center justify-center
        bg-[#9bbc0f]
        rounded-sm
        border-2 border-[#0f380f]
        shadow-[2px_2px_0px_0px_rgba(0,0,0,0.3)]
        transition-transform duration-200
        hover:scale-110
      `}
      title={`채점봇 (${emotion})`}
    >
      <span className="select-none">{emotionEmojis[emotion]}</span>
    </div>
  );
};
